// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mev as _mev } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mev chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7518
 * Chain Name: MEVerse Chain Mainnet
 * Default Block Explorer: https://www.meversescan.io
 * Default RPC URL: https://rpc.meversemainnet.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mev } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mev,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mev = createCommon({
	..._mev,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
